import { Minus, TrendingDown, TrendingUp } from 'lucide-react';
import {
  DashboardDataTableColumnKind,
  type DashboardDataTableColumnDefinition,
} from '@shigo-ui/dashboard-ui';
import { dashboardT } from '../../../../../lib/messages';
import { formatNumber } from '../../../../../lib/format';
import { dashboardTrendTone } from '../../../trend';

export function metricColumn<T>(
  id: string,
  key: Parameters<typeof dashboardT>[0],
  value: (row: T) => number | null | undefined,
  change: (row: T) => number | null | undefined,
  showComparison: boolean,
  formatter: (value: number | null | undefined) => string,
) {
  return {
    id,
    header: dashboardT(key),
    kind: DashboardDataTableColumnKind.Custom,
    className: 'text-right tabular-nums',
    headerClassName: 'text-right',
    cell: (row: T) => (
      <div className="flex flex-col items-end gap-0.5">
        <span>{formatter(value(row))}</span>
        {showComparison ? changeIndicator(change(row)) : null}
      </div>
    ),
  } satisfies DashboardDataTableColumnDefinition<T>;
}

export function changeIndicator(value: number | null | undefined) {
  if (value === null || value === undefined) return null;
  const Icon = trendIcon(value);
  const tone = dashboardTrendTone(value);
  return (
    <span className={`${tone.className} inline-flex items-center gap-1 text-[11px]`}>
      <Icon className="h-3 w-3" aria-hidden="true" />
      {value > 0 ? '+' : ''}
      {formatNumber(value, 2)}%
    </span>
  );
}

function trendIcon(value: number) {
  if (value > 0) return TrendingUp;
  if (value < 0) return TrendingDown;
  return Minus;
}
